import { PatientActivity } from "components/PaymentsLanding/Tabs/PatientActivity/PatientActivity";
import { createFileRoute } from "@tanstack/react-router";
import { getPatientActivityDefaultSearch } from "utils/routeDefaults";
import { useHeaderDates } from "molecules/filters/rangePicker/datePickerContext";

export interface PatientActivitySearchParams {
    patientName: string;
    status: ("unsent" | "outstanding" | "paid")[];
}

export type PatientActivitySearchParamsPartial = Partial<PatientActivitySearchParams>;

export const Route = createFileRoute("/history/patients")({
    component: PatientActivityRoute,
    validateSearch: getPatientActivityDefaultSearch,
});

function PatientActivityRoute() {
    const { patientName, status } = Route.useSearch() satisfies PatientActivitySearchParams;
    const [start, end] = useHeaderDates();

    return start && end ? (
        <PatientActivity active={true} startDateMs={start} endDateMs={end} patientName={patientName} status={status} />
    ) : null;
}
